import React from 'react';
import PropTypes from 'prop-types';

const NavToggle = ({ onClick, isOpen, modifierClass, children }) => {

  function handleClick( e ) {

    if ( typeof onClick === 'function' ) {

      onClick( e );

    }

  }

  return (
    <button data-is-open={ isOpen }
      className={ `nav-toggle ${ modifierClass || '' }` }
      onClick={ handleClick }
    >
      { children }
    </button>
  );

};

NavToggle.propTypes = {
  modifierClass: PropTypes.string,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
};

export default NavToggle;
